import React from "react";
import { TitleH3 } from "../../../../../shared/native/typography.styles";
import HigherEducationImg from "../../../../../../core/static/img/applications/higher_education.svg";
import { GosuslugiHighEducationCardContainer } from "./gosuslugiHighEducationCard.styles";

const GOSUSLUGI_VUZ_URL = "https://www.gosuslugi.ru/vuzonline";

const GosuslugiHighEducationCard: React.FC = () => (
  <GosuslugiHighEducationCardContainer
    href={GOSUSLUGI_VUZ_URL}
    target="_blank"
    rel="noopener noreferrer"
  >
    <div className="content">
      <img src={HigherEducationImg} alt="Высшее образование" />
      <div className="overlayText">
        <p className="overlayTextContent">
          Уважаемый абитуриент!
          <br />
          Вам необходимо зайти под логином (Код поступающего) и паролем, которые были вам отправлены
          на почту после подачи заявления через портал госуслуги. Если вы еще не подали заявление
          через госуслуги, то перейдите по <span className="linkWord">ссылке</span>
        </p>
      </div>
    </div>
    <div className="footer">
      <TitleH3>Высшее образование</TitleH3>
    </div>
  </GosuslugiHighEducationCardContainer>
);

export default GosuslugiHighEducationCard;
